<template>
  <b-container>
    <div class="text-right"></div>
    <div>
      <v-card-title>
        <v-text-field v-model="search" append-icon="mdi-magnify" hide-details single-line>
          <template slot="label">
            <div class="search-datatable">
              <i class="fas fa-search fa-fw"></i>
              {{ $t("public.components.workschedule.WorkscheduleBlock.find") }}
            </div>
          </template>
        </v-text-field>
      </v-card-title>
      <v-data-table :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'fas fa-arrow-left',
        lastIcon: 'fas fa-arrow-right',
        prevIcon: 'fas fa-minus',
        nextIcon: 'fas fa-plus',
        'items-per-page-options': [10, 25, 50],
      }" :headers="headers" :items="seasons" :search="search" item-key="id">
        <template v-slot:item.hours="{ item }">
          <div v-if="item.seasonHours && item.seasonHours.length !== 0">
            <b-badge v-for="(value, index) in item.seasonHours" :key="index" class="mr-2 text-uppercase"
              variant="success">
              {{ value.timeStart }} - {{ value.timeEnd }}
            </b-badge>
          </div>
          <b-badge v-else class="mr-2 text-uppercase" variant="primary">
            {{ $t("public.components.workschedule.WorkscheduleBlock.lockDay") }}
          </b-badge>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="div-table-data">
            <button :id="'btnSee' + item.id" class="item" v-on:click="seeSeason(item.id)">
              <i class="ri-eye-line"></i>
            </button>
            <b-popover :target="'btnSee' + item.id" placement="botton" triggers="hover focus">
              <template #title>{{
                $t("public.components.workschedule.WorkscheduleBlock.seeSeason")
              }}
              </template>
            </b-popover>
            <button :id="'btnUpdate' + item.id" class="item" v-on:click="update(item.id)">
              <i class="ri-refresh-line"></i>
            </button>
            <b-popover :target="'btnUpdate' + item.id" placement="botton" triggers="hover focus">
              <template #title>{{
                $t("public.components.workschedule.WorkscheduleBlock.refresh")
              }}
              </template>
            </b-popover>
            <button :id="'btnCreateHourSeason' + item.id" class="item" v-on:click="createHourSeason(item.id)">
              <i class="ri-calendar-line"></i>
            </button>
            <b-popover :target="'btnCreateHourSeason' + item.id" placement="botton" triggers="hover focus">
              <template #title>{{
                $t(
                  "public.components.workschedule.WorkscheduleBlock.createTimeLaps"
                )
              }}
              </template>
            </b-popover>
            <button :id="'btnDelete' + item.id" class="item" v-on:click="deleteSeason(item.id)">
              <i class="ri-delete-bin-line"></i>
            </button>
            <b-popover :target="'btnDelete' + item.id" placement="botton" triggers="hover focus">
              <template #title>{{
                $t(
                  "public.components.workschedule.WorkscheduleBlock.deleteSeason"
                )
              }}
              </template>
            </b-popover>
          </div>
        </template>
      </v-data-table>
    </div>
    <b-modal id="modal-schedule-block" cancel-title="Cerrar" centered ok-title="Crear" @ok="saveFormStep1">
      <template #modal-title><span v-if="optionModalSchedule === 'create'">
          {{
            $t(
              "public.components.workschedule.WorkscheduleBlock.modal.createInactiveSeason"
            )
          }}
        </span>
        <span v-else>
          {{
            $t(
              "public.components.workschedule.WorkscheduleBlock.modal.refreshActiveSeason"
            )
          }}
        </span>
      </template>
      <template #modal-ok>
        <div v-if="optionModalSchedule === 'create'">
          {{
            $t("public.components.workschedule.WorkscheduleBlock.modal.create")
          }}
        </div>
        <div v-else>
          {{
            $t("public.components.workschedule.WorkscheduleBlock.modal.refresh")
          }}
        </div>
      </template>
      <template #modal-cancel>{{
        $t("public.auth.patient.schedule.modalCreate.btnCancel")
      }}
      </template>

      <b-form-group label-for="name">
        <template slot="label">{{
          $t("public.components.workschedule.WorkscheduleBlock.modal.name")
        }}: *
        </template>
        <b-form-input v-model="name" :disabled="disabled" type="text" v-bind:class="{
          'text-danger': isFormNameErrors,
          'is-invalid': isFormNameErrors,
        }" @blur="checkName(name)"></b-form-input>
        <ul v-if="isFormNameErrors">
          <li v-for="(error, index) in validatorStep1.getErrors('name')" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>

      <b-form-group label-for="dateStart">
        <template slot="label">{{
          $t(
            "public.components.workschedule.WorkscheduleBlock.modal.initialDate"
          )
        }}: *
        </template>
        <date-picker v-model="dateStart" :disabled="disabled" :format="myFormat" :formatter="momentFormat" class="w-100"
          type="date" v-bind:class="{
            'text-danger': isFormDateStartErrors,
            'is-invalid': isFormDateStartErrors,
          }" @blur="checkDateStart(dateStart)"></date-picker>
        <ul v-if="isFormDateStartErrors">
          <li v-for="(error, index) in validatorStep1.getErrors('dateStart')" v-bind:key="index"
            class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>

      <b-form-group label-for="dateEnd">
        <template slot="label">{{
          $t(
            "public.components.workschedule.WorkscheduleBlock.modal.finalDate"
          )
        }}: *
        </template>
        <date-picker v-model="dateEnd" :disabled="disabled" :format="myFormat" :formatter="momentFormat" class="w-100"
          type="date" v-bind:class="{
            'text-danger': isFormDateEndErrors,
            'is-invalid': isFormDateEndErrors,
          }" @blur="checkDateEnd(dateEnd)"></date-picker>
        <ul v-if="isFormDateEndErrors">
          <li v-for="(error, index) in validatorStep1.getErrors('dateEnd')" v-bind:key="index"
            class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="seasonHours">
        <template slot="label">{{
          $t(
            "public.components.workschedule.WorkscheduleBlock.modal.timeLaps"
          )
        }}:
        </template>
        <ul v-if="seasonHours && seasonHours.length !== 0">
          <li v-for="(item, index) in seasonHours" :key="index" class="list-group-item">
            {{ item.timeStart }} - {{ item.timeEnd }}
            <div class="float-right">
              <i class="fas fa-trash-alt text-danger cursor-point" v-on:click="deleteHourSeason(item.id)"></i>
            </div>
          </li>
        </ul>
        <b-alert v-else show variant="primary">{{
          $t("public.components.workschedule.WorkscheduleBlock.lockDay")
        }}
        </b-alert>
      </b-form-group>
    </b-modal>
    <b-modal id="modal-info-schedule-block" cancel-title="Cerrar" centered hide-footer size="lg">
      <template #modal-title>{{
        $t("public.components.workschedule.WorkscheduleBlock.modal.info")
      }}
      </template>
      <b-form-group label-for="dateStartInfo">
        <template slot="label">{{
          $t("public.components.workschedule.WorkscheduleBlock.modal.season")
        }}:
        </template>
        <ul class="list-group">
          <li v-if="nameInfo" class="list-group-item">
            {{ nameInfo }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="dateStartInfo">
        <template slot="label">{{
          $t(
            "public.components.workschedule.WorkscheduleBlock.modal.initialDate"
          )
        }}:
        </template>
        <ul class="list-group">
          <li v-if="dateStartInfo" class="list-group-item">
            {{ dateStartInfo }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="dateEndInfo">
        <template slot="label">{{
          $t(
            "public.components.workschedule.WorkscheduleBlock.modal.finalDate"
          )
        }}:
        </template>
        <ul class="list-group">
          <li v-if="dateEndInfo" class="list-group-item">
            {{ dateEndInfo }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="seasonHoursInfo">
        <template slot="label">{{
          $t(
            "public.components.workschedule.WorkscheduleBlock.modal.timeLaps"
          )
        }}:
        </template>
        <ul v-if="seasonHoursInfo && seasonHoursInfo.length !== 0">
          <li v-for="(item, index) in seasonHoursInfo" :key="index" class="list-group-item">
            {{ item.timeStart }} - {{ item.timeEnd }}
          </li>
        </ul>
        <b-alert v-else show variant="primary">{{
          $t("public.components.workschedule.WorkscheduleBlock.lockDay")
        }}
        </b-alert>
      </b-form-group>
    </b-modal>
    <b-modal id="modal-create-hour-block" cancel-title="Cerrar" centered ok-title="Crear" size="lg" @ok="saveFormStep2">
      <template #modal-title>{{
        $t("public.components.workschedule.WorkscheduleBlock.createTimeLaps")
      }}
      </template>
      <b-form-group label-for="timeStartHour">
        <template slot="label">{{
          $t(
            "public.components.workschedule.WorkscheduleBlock.modal.startTime"
          )
        }}: *
        </template>
        <b-form-input id="timeStartHour" v-model="timeStartHour" :disabled="disabled" type="time" v-bind:class="{
          'text-danger': isFormTimeStartHourErrors,
          'is-invalid': isFormTimeStartHourErrors,
        }" @blur="checkTimeStartHour(timeStartHour)"></b-form-input>
        <ul v-if="isFormTimeStartHourErrors">
          <li v-for="(error, index) in validatorStep2.getErrors('timeStartHour')" v-bind:key="index"
            class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group label-for="timeEndHour">
        <template slot="label">{{
          $t(
            "public.components.workschedule.WorkscheduleBlock.modal.endTime"
          )
        }}: *
        </template>
        <b-form-input id="timeEndHour" v-model="timeEndHour" :disabled="disabled" type="time" v-bind:class="{
          'text-danger': isFormTimeEndHourErrors,
          'is-invalid': isFormTimeEndHourErrors,
        }" @blur="checkTimeEndHour(timeStartHour, timeEndHour)"></b-form-input>
        <ul v-if="isFormTimeEndHourErrors">
          <li v-for="(error, index) in validatorStep2.getErrors('timeEndHour')" v-bind:key="index"
            class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
    </b-modal>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../config/pluginInit";

import validator from "vue-m-validator";
import moment from "moment";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import professionalService from "../../services/professional";
import utilsService from "../../services/utils";

export default {
  name: "WorkscheduleBlock",
  props: ["updateDataComponets", "idProfessional"],
  mounted() {
    xray.index();
    this.getAllSeasons();
  },
  components: {
    validator,
  },
  computed: {
    //FormSchedule
    isFormNameErrors() {
      let errors = this.validatorStep1.getErrors("name");
      return errors && errors.length > 0;
    },
    isFormDateStartErrors() {
      let errors = this.validatorStep1.getErrors("dateStart");
      return errors && errors.length > 0;
    },
    isFormDateEndErrors() {
      let errors = this.validatorStep1.getErrors("dateEnd");
      return errors && errors.length > 0;
    },
    // Form hours
    isFormTimeStartHourErrors() {
      let errors = this.validatorStep2.getErrors("timeStartHour");
      return errors && errors.length > 0;
    },
    isFormTimeEndHourErrors() {
      let errors = this.validatorStep2.getErrors("timeEndHour");
      return errors && errors.length > 0;
    },
  },
  methods: {
    deleteHourSeason(id) {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.deleteHourSeason(self.idProfessional, id),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "DELETE", module: "PROFESSIONAL_WORKSCHEDULE", info: "" });
            self.$bvModal.hide("modal-schedule-block");

            self.updateDataComponets();

            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.workschedule.WorkscheduleBlock.notification.title"
              ),
              text: this.$i18n.t(
                "public.components.workschedule.WorkscheduleBlock.notification.descDelete"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.deleteHourSeason",
            module: "component-account-workscheduleBlock",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({ idProfessional: self.idProfessional, id: id }),
          });
        },
        " "
      );
    },
    seeSeason(id) {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.getSeason(self.idProfessional, id),
        (response) => {
          if (response) {
            self.clearFormScheduleInfo();

            self.idInfo = response.data.id;
            self.nameInfo = response.data.name;
            self.dateStartInfo = moment(response.data.dateStart).format(
              "DD/MM/YYYY"
            );
            self.dateEndInfo = moment(response.data.dateEnd).format(
              "DD/MM/YYYY"
            );
            self.seasonHoursInfo = response.data.seasonHours;

            self.$bvModal.show("modal-info-schedule-block");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getSeason",
            module: "component-account-workscheduleBlock",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({ idProfessional: self.idProfessional, id: id }),
          });
        },
        " "
      );
    },
    deleteSeason(id) {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.deleteSeason(self.idProfessional, id),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "DELETE", module: "PROFESSIONAL_WORKSCHEDULE", info: "" });
            self.updateDataComponets();

            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.workschedule.WorkscheduleBlock.notification.title"
              ),
              text: this.$i18n.t(
                "public.components.workschedule.WorkscheduleBlock.notification.descDeleteSeason"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.deleteSeason",
            module: "component-account-workscheduleBlock",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({ idProfessional: self.idProfessional, id: id }),
          });
        },
        " "
      );
    },
    createHourSeason(id) {
      this.idSeason = id;

      this.$bvModal.show("modal-create-hour-block");
    },
    update(id) {
      //this.openModalSchedule('update', item.id);
      this.getSeason(id);
    },
    notFirst() {
      this.isFirstRun = false;
    },
    // Modal create hour check
    checkTimeStartHour(_timeStartHour) {
      const TIMESTARTHOUR = _timeStartHour.trim();
      const RULE_1 = {
        expression: !TIMESTARTHOUR || TIMESTARTHOUR === "",
        name: "timeStartHour",
        msg: this.$i18n.t(
          "public.components.workschedule.WorkscheduleBlock.errors.erStartHour"
        ),
      };
      this.validatorStep2.addRule(RULE_1);
      this.notFirst();
    },
    checkTimeEndHour(_timeStartHour, _timeEndHour) {
      const TIMESTARTHOUR = _timeStartHour.trim();
      const TIMEENDHOUR = _timeEndHour.trim();
      const RULE_1 = {
        expression: !TIMEENDHOUR || TIMEENDHOUR === "",
        name: "timeEndHour",
        msg: this.$i18n.t(
          "public.components.workschedule.WorkscheduleBlock.errors.erEndHour"
        ),
      };
      this.validatorStep1.addRule(RULE_1);

      const RULE_2 = {
        expression: moment(TIMESTARTHOUR, [moment.ISO_8601, "HH:mm"]).isAfter(
          moment(TIMEENDHOUR, [moment.ISO_8601, "HH:mm"])
        ),
        name: "TIMEENDHOUR",
        msg: this.$i18n.t(
          "public.components.workschedule.WorkscheduleBlock.errors.erHourEarlier"
        ),
      };
      this.validatorStep2.addRule(RULE_2);
      this.notFirst();
    },

    // Modal create season check
    checkName(_name) {
      const NAME = _name.trim();
      const RULE_1 = {
        expression: !NAME || NAME === "",
        name: "name",
        msg: this.$i18n.t(
          "public.components.workschedule.WorkscheduleBlock.errors.erName"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkDateStart(_dateStart) {
      const DATESTART = _dateStart;
      const RULE_1 = {
        expression: !DATESTART || DATESTART === "",
        name: "dateStart",
        msg: this.$i18n.t(
          "public.components.workschedule.WorkscheduleBlock.errors.erInitialDate"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    checkDateEnd(_dateEnd) {
      const DATEEND = _dateEnd;
      const RULE_1 = {
        expression: !DATEEND || DATEEND === "",
        name: "dateEnd",
        msg: this.$i18n.t(
          "public.components.workschedule.WorkscheduleBlock.errors.erEndDate"
        ),
      };
      this.validatorStep1.addRule(RULE_1);
      this.notFirst();
    },
    clearFormScheduleInfo() {
      this.idInfo = "";
      this.nameInfo = "";
      this.dateStartInfo = "";
      this.dateEndInfo = "";
      this.seasonhoursInfo = [];
    },
    clearFormSchedule() {
      this.id = "";
      this.name = "";
      this.dateStart = "";
      this.dateEnd = "";
    },
    openModalSchedule(option, id) {
      this.optionModalSchedule = option;
      this.disabledSchedule = false;
      this.clearFormSchedule();
      this.validatorStep1.errors = [];
      this.$bvModal.show("modal-schedule-block");
    },
    saveSchedule() {
      if (this.optionModalSchedule === "create") {
        this.createSeason();
      }
      if (this.optionModalSchedule === "update") {
        this.updateSeason();
      }
    },
    getSeason(id) {
      let self = this;

      this.$awn.asyncBlock(
        professionalService.getSeason(self.idProfessional, id),
        (response) => {
          if (response) {
            self.openModalSchedule("update", "");
            self.clearFormSchedule();
            self.validatorStep1.errors = [];
            self.id = response.data.id;
            self.name = response.data.name;
            self.dateStart = moment(response.data.dateStart).toDate();
            self.dateEnd = moment(response.data.dateEnd).toDate();
            self.seasonHours = response.data.seasonHours;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getSeason",
            module: "component-account-workscheduleBlock",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({ idProfessional: self.idProfessional, id: id }),
          });
        },
        " "
      );
    },
    updateSeason() {
      let self = this;

      let data = {
        id: this.id,
        name: this.name,
        dateStart: utilsService.adjustDateTime(moment(this.dateStart).format("DD/MM/YYYY HH:mm"), "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"),
        dateEnd: utilsService.adjustDateTime(moment(this.dateEnd).format("DD/MM/YYYY HH:mm"), "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"),
      };

      this.$awn.asyncBlock(
        professionalService.updateSeason(self.idProfessional, data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_WORKSCHEDULE", info: "" });
            self.$bvModal.hide("modal-schedule-block");
            self.updateDataComponets();
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.workschedule.WorkscheduleBlock.notification.title"
              ),
              text: this.$i18n.t(
                "public.components.workschedule.WorkscheduleBlock.notification.descRefreshSeason"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.updateSeason",
            module: "component-account-workscheduleBlock",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({ idProfessional: self.idProfessional, data: data }),
          });
        },
        " "
      );
    },
    createSeason() {
      let self = this;

      let data = {
        name: this.name,
        dateStart: utilsService.adjustDateTime(moment(this.dateStart).format("DD/MM/YYYY HH:mm"), "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"),
        dateEnd: utilsService.adjustDateTime(moment(this.dateEnd).format("DD/MM/YYYY HH:mm"), "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"),
      };

      this.$awn.asyncBlock(
        professionalService.createSeason(self.idProfessional, data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_WORKSCHEDULE", info: "" });
            self.$bvModal.hide("modal-schedule-block");
            self.updateDataComponets();
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.workschedule.WorkscheduleBlock.notification.title"
              ),
              text: this.$i18n.t(
                "public.components.workschedule.WorkscheduleBlock.notification.descCreateSeason"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.createSeason",
            module: "component-account-workscheduleBlock",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({ idProfessional: self.idProfessional, data: data }),
          });
        },
        " "
      );
    },
    async getAllSeasons() {
      let self = this;

      professionalService
        .getAllSeason(self.idProfessional)
        .then((response) => {
          if (response) {
            self.seasons = response.data;

            if (self.seasons && self.seasons.length !== 0) {
              self.seasons.forEach(function (season) {
                self.startDate = new Date(season.start);
              });
            }
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAllSeason",
            module: "component-account-workscheduleBlock",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({ idProfessional: self.idProfessional }),
          });
        });
    },
    checkFormStep1() {
      this.checkName(this.name);
      this.checkDateStart(this.dateStart);
      this.checkDateEnd(this.dateEnd);
    },
    saveFormStep1(evt) {
      evt.preventDefault();
      this.checkFormStep1();
      if (this.validatorStep1.errors.length === 0) {
        this.saveSchedule();
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.components.workschedule.WorkscheduleBlock.notification.error"
          ),
          text: this.$i18n.t(
            "public.components.workschedule.WorkscheduleBlock.notification.descErrorStep1"
          ),
          type: "error",
        });
      }
    },
    checkFormStep2() {
      this.checkTimeEndHour(this.timeStartHour, this.timeEndHour);
      this.checkTimeStartHour(this.timeStartHour);
    },
    saveFormStep2(evt) {
      let self = this;
      evt.preventDefault();
      self.checkFormStep2();
      if (this.validatorStep2.errors.length === 0) {
        self.saveHour();
      } else {
        self.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.components.workschedule.WorkscheduleBlock.notification.error"
          ),
          text: this.$i18n.t(
            "public.components.workschedule.WorkscheduleBlock.notification.descErrorStep2"
          ),
          type: "error",
        });
      }
    },
    saveHour() {
      let self = this;

      let data = {
        idSeason: this.idSeason,
        timeStart: this.timeStartHour,
        timeEnd: this.timeEndHour,
      };

      this.$awn.asyncBlock(
        professionalService.createHourSeason(self.idProfessional, data),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_WORKSCHEDULE", info: "" });
            self.$bvModal.hide("modal-create-hour-block");
            self.updateDataComponets();

            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.workschedule.WorkscheduleBlock.notification.title"
              ),
              text: this.$i18n.t(
                "public.components.workschedule.WorkscheduleBlock.notification.descSaveTimeLaps"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.createHourSeason",
            module: "component-account-workscheduleBlock",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({ idProfessional: self.idProfessional, data: data }),
          });
        },
        " "
      );
    },
  },
  data() {
    return {
      search: "",

      startDate: new Date(),
      // Form hour
      idSeason: "",
      timeStartHour: "",
      timeEndHour: "",
      // Form season info
      idInfo: "",
      nameInfo: "",
      dateStartInfo: "",
      dateEndInfo: "",
      seasonHoursInfo: [],

      //Form season
      id: "",
      name: "",
      dateStart: "",
      dateEnd: "",
      seasonHours: [],

      disabled: false,
      isFirstRun: true,
      isValidateStep1: false,
      showSeason: true,
      validatorStep1: validator,
      validatorStep2: validator,
      visitTypeSelect: [],
      headers: [
        {
          text: this.$i18n.t(
            "public.components.workschedule.WorkscheduleBlock.headers.name"
          ),
          align: "start",
          value: "name",
        },
        {
          text: this.$i18n.t(
            "public.components.workschedule.WorkscheduleBlock.headers.initialDate"
          ),
          value: "dateStart",
        },
        {
          text: this.$i18n.t(
            "public.components.workschedule.WorkscheduleBlock.headers.dateEnd"
          ),
          value: "dateEnd",
        },
        {
          text: this.$i18n.t(
            "public.components.workschedule.WorkscheduleBlock.headers.timeLaps"
          ),
          value: "hours",
        },
        { text: "", value: "actions" },
      ],
      seasons: [],

      //vue2-data-picker
      myFormat: "DD/MM/YYYY",
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("LL") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          // a number
        },
      },
    };
  },
  components: {
    DatePicker,
    Multiselect,
  },
};
</script>